import React from 'react'

import * as c from '../../../common'
import * as r from '../../../react-utils'

import NirvanaContractView from '../../comps/NirvanaContractView'

export type NirvanaContractProps = c.r<{
  customerID: string
  isPDF: boolean
  toggleCompanySignatureModal(): void
  toggleSignatureModal(): void
}>

export default React.memo<NirvanaContractProps>(function NirvanaContract({
  customerID,
  isPDF,
  toggleCompanySignatureModal,
  toggleSignatureModal,
}) {
  //#region styling

  //#endregion
  //#region global
  const {
    contractCompanyFull,
    contractCompaniesCurrStateArr,
    handleContractCompany,
  } = r.useContractCompany(customerID)

  const totalCost = r.useTotalCost('customer', customerID)

  const [customerData] = r.useCustomer(customerID)

  const {
    c_signature,
    c_signature_date,
    customerAddress,
    customerEmail,
    customerName,
    customerPhone,
    customerPhoneAlt,
    homeRep,
    report_company_signature,
    report_company_signature_date,
    solarCompany,
  } = customerData

  type PublicSignature = { signature: string; timestamp: number }
  const [publicSignatureVal, publicSignatureSet] =
    React.useState<PublicSignature | null>(null)

  React.useEffect(() => {
    const ref = c.getDatabase().ref(`ContractSignature/${customerID}`)

    ref.on('value', (snapshot) => {
      const data = snapshot.val() as PublicSignature | null
      publicSignatureSet(data)
    })
    return () => {
      ref.off()
    }
  }, [customerID])
  //#endregion
  //#region local
  //
  const [finance, , financeHandle] = r.useCustomerFieldInput(
    customerID,
    'report_nirvana_finance',
  )
  const [upfront, , upfrontHandle] = r.useCustomerFieldInput(
    customerID,
    'report_nirvana_upfront',
  )
  const [remaining, , remainingHandle] = r.useCustomerFieldInput(
    customerID,
    'report_nirvana_remaining',
  )
  //#endregion

  const rows = React.useMemo((): readonly c.IContractDetailRow[] => {
    return c.buildContractRows(customerData)
  }, [customerData])

  return (
    <NirvanaContractView
      amountFinance={finance}
      amountFinanceOnChange={financeHandle}
      amountRemaining={remaining}
      amountRemainingOnChange={remainingHandle}
      amountUpfront={upfront}
      amountUpfrontOnChange={upfrontHandle}
      contractCompanyFull={contractCompanyFull}
      contractCompanyOnChange={handleContractCompany}
      contractCompanyOpts={contractCompaniesCurrStateArr}
      customerAddress={customerAddress}
      customerEmail={customerEmail}
      customerName={customerName}
      customerPhone={customerPhone}
      customerPhoneAlt={customerPhoneAlt}
      customerSignature={publicSignatureVal?.signature || c_signature}
      customerSignatureDate={publicSignatureVal?.timestamp || c_signature_date}
      isPDF={isPDF}
      repName={homeRep}
      repSignature={report_company_signature}
      repSignatureDate={report_company_signature_date}
      rows={rows}
      state={solarCompany}
      toggleCompanySignatureModal={toggleCompanySignatureModal}
      toggleSignatureModal={toggleSignatureModal}
      totalCostCustomer={totalCost}
    />
  )
})
